import { render, staticRenderFns } from "./TreeEditCotejo.vue?vue&type=template&id=9d21715e&scoped=true"
import script from "./TreeEditCotejo.vue?vue&type=script&lang=js"
export * from "./TreeEditCotejo.vue?vue&type=script&lang=js"
import style0 from "./TreeEditCotejo.vue?vue&type=style&index=0&id=9d21715e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d21715e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d21715e')) {
      api.createRecord('9d21715e', component.options)
    } else {
      api.reload('9d21715e', component.options)
    }
    module.hot.accept("./TreeEditCotejo.vue?vue&type=template&id=9d21715e&scoped=true", function () {
      api.rerender('9d21715e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/TreeEditCotejo.vue"
export default component.exports